import { create } from "zustand";
import { UpdateFn, Updater } from "../../types";
import { Activity } from "../../components/activity/types";

interface State {
  searchTerm: string;
  activities: Array<Activity>;
}

interface Action {
  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>) => void;
  setSearchTerm: UpdateFn<string>;
  setActivities: UpdateFn<Array<Activity>>;
}

const useHistoryPageStore = create<State & Action>((set, get) => ({
  searchTerm: "",
  activities: [],

  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>): void => {
    if (typeof updater === "function") {
      set((state) => ({ [key]: updater(state[key]) }));
    } else {
      set({ [key]: updater });
    }
  },

  setSearchTerm: (updater) => {
    get().setter("searchTerm", updater);
  },

  setActivities: (updater) => {
    get().setter("activities", updater);
  },
}));

export default useHistoryPageStore;
